export const NodeType = {
    Element: 'element',
    TextNode: 'textNode',
    Text: 'text',
};
//# sourceMappingURL=nodeTypes.js.map